import { useEffect, useState } from "react";
import { X, Lock } from "lucide-react";

export default function PinPrompt({ open, mode, onClose, onSubmit, error }) {
  // mode: "verify" | "set"
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");

  useEffect(() => {
    if (open) { setPin(""); setConfirm(""); }
  }, [open]);

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    if (!pin) return;
    if (mode === "set" && pin !== confirm) {
      onSubmit && onSubmit(null, "PINs do not match");
      return;
    }
    onSubmit && onSubmit(pin);
  };

  return (
    <div className="modal-overlay" data-testid="pin-prompt-modal">
      <form onSubmit={submit} className="brutal-card p-6 w-full max-w-sm text-center">
        <div className="flex items-start justify-between mb-2">
          <Lock className="text-[color:var(--ink)]" />
          <button type="button" className="pill-btn" onClick={onClose} data-testid="pin-prompt-close">
            <X size={16} />
          </button>
        </div>
        <h2 className="display text-2xl font-bold mt-1 mb-1">
          {mode === "set" ? "Set caregiver PIN" : "Caregiver PIN"}
        </h2>
        <p className="text-[color:var(--ink-soft)] mb-4">
          {mode === "set" ? "Pick a 4-digit PIN to lock edit mode." : "Enter the PIN to unlock edit mode."}
        </p>

        <input
          autoFocus
          className="brutal-input text-center text-3xl tracking-[0.5em] mb-3"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
          placeholder="••••"
          data-testid="pin-input"
        />

        {mode === "set" && (
          <input
            className="brutal-input text-center text-3xl tracking-[0.5em] mb-3"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={6}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value.replace(/\D/g, ""))}
            placeholder="confirm"
            data-testid="pin-confirm-input"
          />
        )}

        {error && (
          <div className="text-[color:var(--coral-deep)] mb-3" data-testid="pin-error">
            {error}
          </div>
        )}

        <button type="submit" className="pill-btn primary w-full" data-testid="pin-submit">
          {mode === "set" ? "Save PIN" : "Unlock"}
        </button>
      </form>
    </div>
  );
}
